import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { ParamMap } from '@angular/router'
import { catchError, switchMap } from 'rxjs/operators'
import { Observable, of } from 'rxjs'
import { LOGGER_SERVICE } from 'src/app/logger/logger.config'
import { LoggerService } from 'src/app/logger/logger.interface'
import { EXPERIENCE_API_SPORTS_BASE_PATH, EXPERIENCE_API_VERSION } from 'src/app/app.config'
import { WebContentWithRightRailLayout } from '@flocasts/experience-service-types'
import { VerticalService } from 'src/app/singleton-services/vertical.service'

@Injectable()
export class SportsDataService {
  constructor(
    private readonly http: HttpClient,
    @Inject(LOGGER_SERVICE) private readonly logger: LoggerService,
    private readonly verticalService: VerticalService
  ) {}

  public readonly getSportsLayout = (): Observable<WebContentWithRightRailLayout | undefined> => {
    return this.verticalService.siteId$.pipe(
      switchMap(siteId => {
        const params = new HttpParams({
          fromObject: {
            version: EXPERIENCE_API_VERSION,
            site_id: siteId
          }
        })
        return this.http.get<WebContentWithRightRailLayout>(EXPERIENCE_API_SPORTS_BASE_PATH, { params }).pipe(
          catchError(err => {
            this.logger.error(err.message, err.error)
            return of(undefined)
          })
        )
      })
    )
  }

  // TODO add return type Observable<Type... | undefined>
  // TODO for favorites - we will need cache data service added
  public readonly getSportById = (id: number, tab: string | null | undefined, querParams: ParamMap | null) => {
    const params = new HttpParams({
      fromObject: {
        version: EXPERIENCE_API_VERSION
      }
    })

    // TODO: set any conditional params from query params

    const endpoint = `${EXPERIENCE_API_SPORTS_BASE_PATH}/${id}${!!tab ? `/${tab}` : ''}`
    // TODO set type this.http.get<type>...
    return this.http.get(endpoint, { params }).pipe(
      catchError(err => {
        this.logger.error(err.message, err.error)
        return of(undefined)
      })
    )
  }
}
